import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const TIPO_VISITA = [
  { v: "preventiva", l: "Preventiva" }, { v: "periodica", l: "Periodica" },
  { v: "cambio_mansione", l: "Cambio mansione" }, { v: "rientro", l: "Rientro (>60gg)" },
  { v: "su_richiesta", l: "Su richiesta" }, { v: "cessazione", l: "Cessazione" },
  { v: "preassuntiva", l: "Preassuntiva" },
];
export const GIUDIZIO = [
  { v: "idoneo", l: "Idoneo (idoneità piena)" }, { v: "idoneo_con_prescrizioni", l: "Idoneo con limitazioni/prescrizioni" },
  { v: "non_idoneo_temporaneo", l: "Inidoneità temporanea" }, { v: "non_idoneo_permanente", l: "Inidoneità permanente" },
];
const FATTORI_RISCHIO = [
  "Movimentazione manuale dei carichi", "Agenti chimici", "Rumore", "Vibrazioni",
  "Videoterminali", "Agenti biologici", "Cancerogeni/mutageni", "Radiazioni", "Altro",
];
const NONE = "__none__";

export const emptyVisita = () => ({
  azienda: "", azienda_id: "", medico_competente: "", medico_competente_codice: "", preventivo_id: "",
  lavoratore_nome: "", codice_fiscale: "", data_nascita: "", sesso: "", mansione: "", reparto: "",
  fattori_rischio_list: [], fattori_rischio: "", tipo_visita: "periodica", data_visita: "", accertamenti: "",
  giudizio_idoneita: "idoneo", prescrizioni: "", malattia_professionale: false, malattia_professionale_desc: "",
  alcol: false, tossicodipendenza: false, scadenza_prossima: "", note: "",
});

const F = ({ label, span = "", children }) => (
  <div className={span}><Label className="text-xs text-slate-600">{label}</Label>{children}</div>
);

function Collegamenti({ v, set, companies, incarichi, medici }) {
  const pickIncarico = (id) => {
    if (id === NONE) return set({ preventivo_id: "" });
    const p = incarichi.find((x) => x.id === id) || {};
    set({ preventivo_id: id, azienda: v.azienda || p.azienda || p.cliente_nome || "",
      medico_competente: v.medico_competente || p.medico_competente || "", medico_competente_codice: v.medico_competente_codice || p.medico_competente_codice || "" });
  };
  const pickAzienda = (id) => {
    if (id === NONE) return set({ azienda_id: "" });
    const c = companies.find((x) => x.id === id);
    set({ azienda_id: id, azienda: c?.nome || "" });
  };
  return (
    <div className="grid sm:grid-cols-2 gap-3 p-3 rounded-lg bg-teal-50/50 border border-teal-100">
      <F label="Azienda cliente (anagrafica)">
        <Select value={v.azienda_id || NONE} onValueChange={pickAzienda}>
          <SelectTrigger data-testid="vf-azienda-select"><SelectValue placeholder="Seleziona…" /></SelectTrigger>
          <SelectContent><SelectItem value={NONE}>— Inserisci a mano —</SelectItem>{companies.map((c) => <SelectItem key={c.id} value={c.id}>{c.nome}</SelectItem>)}</SelectContent>
        </Select>
      </F>
      <F label="Azienda (nome) *"><Input value={v.azienda} onChange={(e) => set({ azienda: e.target.value, azienda_id: "" })} data-testid="vf-azienda" /></F>
      <F label="Medico incaricato *">
        <Input list="mc-medici" value={v.medico_competente} onChange={(e) => set({ medico_competente: e.target.value })} placeholder="Dott. …" data-testid="vf-medico" />
        <datalist id="mc-medici">{medici.map((m) => <option key={m} value={m} />)}</datalist>
      </F>
      <F label="Iscrizione / codice medico"><Input value={v.medico_competente_codice} onChange={(e) => set({ medico_competente_codice: e.target.value })} data-testid="vf-medico-codice" /></F>
      <F label="Incarico collegato (facoltativo)" span="sm:col-span-2">
        <Select value={v.preventivo_id || NONE} onValueChange={pickIncarico}>
          <SelectTrigger data-testid="vf-incarico"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value={NONE}>Nessun incarico</SelectItem>{incarichi.map((p) => <SelectItem key={p.id} value={p.id}>#{p.numero} · {p.azienda || p.cliente_nome}</SelectItem>)}</SelectContent>
        </Select>
      </F>
    </div>
  );
}

function Lavoratore({ v, set }) {
  return (
    <div className="grid sm:grid-cols-12 gap-3">
      <F label="Lavoratore *" span="sm:col-span-4"><Input value={v.lavoratore_nome} onChange={(e) => set({ lavoratore_nome: e.target.value })} data-testid="vf-lavoratore" /></F>
      <F label="Codice fiscale" span="sm:col-span-3"><Input value={v.codice_fiscale} onChange={(e) => set({ codice_fiscale: e.target.value.toUpperCase() })} data-testid="vf-cf" /></F>
      <F label="Sesso" span="sm:col-span-2">
        <Select value={v.sesso || undefined} onValueChange={(val) => set({ sesso: val })}><SelectTrigger data-testid="vf-sesso"><SelectValue placeholder="—" /></SelectTrigger><SelectContent><SelectItem value="M">M</SelectItem><SelectItem value="F">F</SelectItem></SelectContent></Select>
      </F>
      <F label="Data di nascita" span="sm:col-span-3"><Input type="date" value={v.data_nascita} onChange={(e) => set({ data_nascita: e.target.value })} data-testid="vf-nascita" /></F>
      <F label="Mansione" span="sm:col-span-6"><Input value={v.mansione} onChange={(e) => set({ mansione: e.target.value })} data-testid="vf-mansione" /></F>
      <F label="Reparto" span="sm:col-span-6"><Input value={v.reparto} onChange={(e) => set({ reparto: e.target.value })} data-testid="vf-reparto" /></F>
    </div>
  );
}

function Rischi({ v, set }) {
  const toggle = (fr) => {
    const cur = v.fattori_rischio_list || [];
    set({ fattori_rischio_list: cur.includes(fr) ? cur.filter((x) => x !== fr) : [...cur, fr] });
  };
  return (
    <div>
      <Label className="text-xs text-slate-600">Esposizione ai rischi</Label>
      <div className="flex flex-wrap gap-1.5 mt-1" data-testid="vf-rischi">
        {FATTORI_RISCHIO.map((fr) => {
          const on = (v.fattori_rischio_list || []).includes(fr);
          return (
            <button type="button" key={fr} onClick={() => toggle(fr)} data-testid={`vf-rischio-${fr}`}
              className={`text-[11px] px-2 py-1 rounded-full border transition-colors ${on ? "bg-teal-600 text-white border-teal-600" : "bg-white text-slate-600 border-slate-200 hover:border-teal-300"}`}>{fr}</button>
          );
        })}
      </div>
    </div>
  );
}

function Esito({ v, set }) {
  return (
    <div className="grid sm:grid-cols-12 gap-3">
      <F label="Tipo visita" span="sm:col-span-4">
        <Select value={v.tipo_visita || "periodica"} onValueChange={(val) => set({ tipo_visita: val })}><SelectTrigger data-testid="vf-tipo"><SelectValue /></SelectTrigger><SelectContent>{TIPO_VISITA.map((t) => <SelectItem key={t.v} value={t.v}>{t.l}</SelectItem>)}</SelectContent></Select>
      </F>
      <F label="Data visita" span="sm:col-span-4"><Input type="date" value={v.data_visita} onChange={(e) => set({ data_visita: e.target.value })} data-testid="vf-data" /></F>
      <F label="Prossima scadenza" span="sm:col-span-4"><Input type="date" value={v.scadenza_prossima} onChange={(e) => set({ scadenza_prossima: e.target.value })} data-testid="vf-scadenza" /></F>
      <F label="Altre esposizioni / note rischio" span="sm:col-span-6"><Input value={v.fattori_rischio} onChange={(e) => set({ fattori_rischio: e.target.value })} data-testid="vf-rischio-note" /></F>
      <F label="Accertamenti effettuati" span="sm:col-span-6"><Input value={v.accertamenti} onChange={(e) => set({ accertamenti: e.target.value })} data-testid="vf-accertamenti" /></F>
      <F label="Giudizio idoneità" span="sm:col-span-5">
        <Select value={v.giudizio_idoneita || "idoneo"} onValueChange={(val) => set({ giudizio_idoneita: val })}><SelectTrigger data-testid="vf-giudizio"><SelectValue /></SelectTrigger><SelectContent>{GIUDIZIO.map((g) => <SelectItem key={g.v} value={g.v}>{g.l}</SelectItem>)}</SelectContent></Select>
      </F>
      <F label="Prescrizioni / limitazioni" span="sm:col-span-7"><Input value={v.prescrizioni} onChange={(e) => set({ prescrizioni: e.target.value })} data-testid="vf-prescrizioni" /></F>
    </div>
  );
}

function Flags({ v, set }) {
  return (
    <div className="grid sm:grid-cols-12 gap-3 items-center pt-2 border-t border-slate-100">
      <div className="sm:col-span-4 flex items-center gap-2"><Switch checked={!!v.malattia_professionale} onCheckedChange={(val) => set({ malattia_professionale: val })} data-testid="vf-malprof" /><Label className="mb-0 text-xs">Malattia professionale</Label></div>
      {v.malattia_professionale && <div className="sm:col-span-4"><Input value={v.malattia_professionale_desc} onChange={(e) => set({ malattia_professionale_desc: e.target.value })} placeholder="Descrizione malattia" data-testid="vf-malprof-desc" /></div>}
      <div className="sm:col-span-2 flex items-center gap-2"><Switch checked={!!v.alcol} onCheckedChange={(val) => set({ alcol: val })} data-testid="vf-alcol" /><Label className="mb-0 text-xs">Alcol (art.41)</Label></div>
      <div className="sm:col-span-2 flex items-center gap-2"><Switch checked={!!v.tossicodipendenza} onCheckedChange={(val) => set({ tossicodipendenza: val })} data-testid="vf-tox" /><Label className="mb-0 text-xs">Tossicod. (art.41)</Label></div>
      <F label="Note" span="sm:col-span-12"><Textarea rows={2} value={v.note} onChange={(e) => set({ note: e.target.value })} data-testid="vf-note" /></F>
    </div>
  );
}

export function VisitaForm({ v, set, companies, incarichi, medici }) {
  return (
    <div className="space-y-4 py-2">
      <Collegamenti v={v} set={set} companies={companies} incarichi={incarichi} medici={medici} />
      <Lavoratore v={v} set={set} />
      <Esito v={v} set={set} />
      <Rischi v={v} set={set} />
      <Flags v={v} set={set} />
    </div>
  );
}
